import { useState, useEffect } from 'react'

export default function useWindowSize () {
  const { innerWidth, innerHeight } = window || {}
  const [windowSize, setWindowSize] = useState({
    width: innerWidth,
    height: innerHeight
  })

  function handleResize () {
    const { innerWidth, innerHeight } = window || {}
    setWindowSize({
      width: innerWidth,
      height: innerHeight
    })
  }

  useEffect(() => {
    if (typeof window === 'undefined') return
    window.addEventListener('resize', handleResize)

    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return windowSize
}
